import { createFileRoute } from '@tanstack/react-router'
import EmployeeAttendance from '@/features/employee-portal/pages/EmployeeAttendance'

export const Route = createFileRoute('/_authenticated/employee-portal/attendance')({
  component: EmployeeAttendance,
})